import { Injectable, InjectionToken } from '@angular/core'
import { UserGroupPermissionId } from '@ftr/contracts/api/user-group'

export const PERMISSION_OVERRIDES = new InjectionToken<PermissionOverrides>('PERMISSION_OVERRIDES')

@Injectable()
export class PermissionOverrides {
  permissions: UserGroupPermissionId[]
}
